import { Apis } from "../../../lib/Apis";

export const tentativeCost = () => {
    const getTentativeCost = async (setTentaiveCostData) => {
        try {
            const response = await Apis.getTentativeCost();
            setTentaiveCostData(response.data.costData[0])
            return response.data.costData
        } catch (error) {
            console.error(error)
        }
    }
    const addOrUpdateTentativeCost = async (data) => {
        try {
            const response = await Apis.addOrUpdateTentativeCost(data);
            return response.data
        } catch (error) {
            console.error(error)
        }
    }
    return {
        getTentativeCost,
        addOrUpdateTentativeCost
    }
}